<template>
  <div class="features">
    <div class="features-container">
      <div v-for="(feature, index) in features"
           :key="index"
           class="feature"
           :class="{ active: feature.active }">
        <img
          :src="feature.icon"
          :alt="feature.title"
          class="feature-icon"
          width="48"
          height="48"
          loading="eager"
          decoding="async"
        >
        <span class="feature-title">{{ feature.title }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const features = computed(() => [
  {
    title: t('index.feature.courses'),
    icon: '/assets/images/index/icons/icon-courses.svg'
  },
  {
    title: t('index.feature.free'),
    icon: '/assets/images/index/icons/icon-free.svg',
    active: true
  },
  {
    title: t('index.feature.mentor'),
    icon: '/assets/images/index/icons/icon-mentor.svg'
  }
])
</script>

<style scoped>
.features {
  margin: 0 auto;
  max-width: 1323px;
  /* position: absolute; */
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 10;
}

.features-container {
  display: flex;
  /* max-width: 1400px; */
  overflow: visible;
  /* margin: 0 50px; */
  /* margin: 0 auto; */
}

.feature {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 23px 32px;
  background: #fff;
  position: relative;
  z-index: 1;
}

.feature:first-child {
  border-radius: 16px 0 0 0;
}

.feature:last-child {
  border-radius: 0 16px 0 0;
}

.feature.active {
  background: linear-gradient(90deg, #09AFEA 0%, #19E089 100%);
}

.feature-icon {
  width: 55px;
  height: 55px;
  object-fit: contain;
}

.feature:first-child .feature-icon {
  width: 50px;
  height: 50px;
}

.feature-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 22px;
  color: var(--color-dark-blue);
}

.feature.active .feature-title {
  color: #fff;
}

@media (max-width: 991px) {
  .features-container {
    flex-direction: column;
  }

  .feature:first-child {
    border-radius: 16px 16px 0 0;
  }

  .feature:last-child {
    border-radius: 0 0 16px 16px;
  }
}

@media (max-width: 768px) {
  .feature:last-child {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  }
}

@media (max-width: 767px) {
  .features {
    padding: 0 20px;
    padding-bottom: 8px;
  }

  .feature {
    padding: 20px;
  }

  .feature-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .features {
    padding: 0;
    padding-bottom: 8px;
  }
  .feature-title {
    font-size: 20px;
  }
  .feature-icon {
  width: 48px;
  height: 48px;
}
.feature {
    padding: 14px 18px;
  }

  .feature:first-child .feature-icon {
    width: 48px;
    height: 48px;
  }
}
</style>